import React from 'react';
import Button from '../Button/Button';
import './SkipLink.scss';

const SkipLink: React.FC = () => {
  const onClick = () => {
    document.querySelector<HTMLElement>('main')?.setAttribute('tabIndex', '-1');
    document.querySelector<HTMLElement>('main')?.focus();
  };

  return (
    <Button onClick={onClick} className="skip-to-content-link" variant="primary-alternate">
      Skip to main content
    </Button>
  );
};

export default SkipLink;
